module.exports = __webpack_public_path__ + "632f605f5a2374256eb2b629dbf5794d.png";